import {
  OPSANIO_APT_RINGS,
  OpsanioPullPolicy,
  OpsanioVersions,
  OpsanioWaves,
} from "src/questionnaires";
export const OPSANIO_PULL_POLICIES: OpsanioPullPolicy[] = [
  "IfNotPresent",
  "Always",
];

export const OPSANIO_WAVES: OpsanioWaves[] = [
  "dev",
  "main",
  "qa",
  "wave1",
  "wave2",
  "wave3",
  "debug",
];

export const defaultWaveData: OpsanioVersions = {
  pullPolicy: "IfNotPresent",
  parentWave: "dev",
  opensearch_dashboard_version: "",
  wazuh_version: "",
  opsanio_plugin_version: "",
  opensearch_version: "",
  opsanio_plugin_tag: "",
  nats_processor_version: "",
  memgraph_version: "",
  mage_version: "",
  nats_version: "",
  promtail_version: "",
  cert_manager: "",
  longhorn: "",
  kubernetes_wodle: "",
  remotelog_wodle: "",
  coredns_version: "",
  codex: "",
  imap_wodle: "",
  osp_wodle: "",
  promtail_wodle: "",
  semaphrone: "",
  snmp_wodle: "",
  wazuh_rules: "",
  webhook_wodle: "",
  netflow_wodle: "",
  most: "",
  cardea: "",
  apt_ring: "",
};

export const defaultInitWave = {
  wazuh_version: "4.14.5",
  opensearch_dashboard_version: "2.19.5",
  opensearch_version: "2.19.5",
  nats_processor_version: "0.6.9",
  memgraph_version: "2.21",
  mage_version: "1.21",
  nats_version: "2.12.6",
  promtail_version: "2.9.10",
  cert_manager: "v1.18.2",
  longhorn: "1.8.2",
};

export const PULL_POLICY_OPTIONS = OPSANIO_PULL_POLICIES.map((options) => ({
  value: options,
  text: options,
}));

/** Empty first: a wave without a ring leaves its appliances unpinned. */
export const APT_RING_OPTIONS: { value: string; text: string }[] = [
  { value: "", text: "-" },
  ...OPSANIO_APT_RINGS.map((ring) => ({ value: ring, text: ring })),
];

export const PARENT_WAVE_OPTIONS: {
  value: OpsanioWaves;
  text: OpsanioWaves;
}[] = OPSANIO_WAVES.map((wave) => ({ value: wave, text: wave }));
